import { z } from "zod";

export const infoScheme = z.object({
  hall: z.number().min(1, 'Оберіть зал'),
  date: z.date().nullable(),
  slotDate: z.string().min(1, 'Оберіть дату'),
  hoursNumber: z.number().min(0.5, 'Оберіть кількість годин'),
  lightSetup: z.string().min(1, 'Оберіть налаштування світла'),
  name: z.string().min(3, 'Введіть ім\'я'),
  phone: z.string().min(16).max(16),
  email: z.string().min(0).nullish(),
  comment: z.string().min(0),
  sendBookingDetailsSms: z.boolean(),
  smsText: z.string()
});

export type BookingInfoFormScheme = z.infer<typeof infoScheme>;
